export const LIMITE_CARACTERES_MENSAGEM = 100;

export function textoPlanoMensagem(html) {
  if (!html) return '';

  if (typeof document !== 'undefined') {
    const elemento = document.createElement('div');
    elemento.innerHTML = html;
    return elemento.textContent || '';
  }

  return String(html).replace(/<[^>]+>/g, '');
}

export function mensagemPrecisaTruncar(texto, limite = LIMITE_CARACTERES_MENSAGEM) {
  return textoPlanoMensagem(texto).length > limite;
}

export function mensagemTextoResumido(texto, limite = LIMITE_CARACTERES_MENSAGEM) {
  return textoPlanoMensagem(texto).slice(0, limite);
}
